import { useState } from "react";
import { format, parse } from "date-fns";
import { CalendarBlank, X } from "@phosphor-icons/react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

const toDate = (iso) => {
  if (!iso) return undefined;
  const d = parse(iso, "yyyy-MM-dd", new Date());
  return Number.isNaN(d.getTime()) ? undefined : d;
};

// Click-to-open calendar for date fields (replaces the fiddly native picker)
export const DateField = ({
  value,
  onChange,
  testid,
  placeholder = "Pick a date",
  className = "",
}) => {
  const [open, setOpen] = useState(false);
  const selected = toDate(value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className={`flex h-11 w-full items-center gap-2 rounded-md border border-zinc-800 bg-zinc-950 px-3 text-left text-sm transition-colors duration-150 hover:border-indigo-500/60 ${className}`}
        >
          <CalendarBlank size={15} weight="bold" className="text-indigo-300" />
          <span className={selected ? "text-zinc-100" : "text-zinc-500"}>
            {selected ? format(selected, "MMM d, yyyy") : placeholder}
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        data-testid={`${testid}-panel`}
        className="w-auto border-zinc-800 bg-zinc-900 p-0"
      >
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected}
          onSelect={(d) => {
            onChange(d ? format(d, "yyyy-MM-dd") : "");
            setOpen(false);
          }}
        />
        {value && (
          <button
            type="button"
            data-testid={`${testid}-clear`}
            onClick={() => {
              onChange("");
              setOpen(false);
            }}
            className="flex w-full items-center justify-center gap-1.5 border-t border-zinc-800 py-2.5 text-[10px] font-bold uppercase tracking-widest text-zinc-400 hover:text-red-300"
          >
            <X size={12} weight="bold" /> Clear date
          </button>
        )}
      </PopoverContent>
    </Popover>
  );
};

export default DateField;
